<script lang="ts">
	// Component properties
	export let active: boolean = false;
</script>

<div class="hamburger" class:is-active={active}>
	<span />
</div>

<style lang="postcss" global>
	.hamburger {
		display: flex;
		align-items: center;
		justify-content: center;

		span {
			display: block;
			position: absolute;
			top: calc(50% - 1px);
			width: 16px;
			height: 2px;
			background-color: var(--color-brown);

			&:before,
			&:after {
				content: '';
				position: absolute;
				display: block;
				left: 0;
				right: 0;
				width: 100%;
				height: 2px;
				background-color: var(--color-brown);
			}

			&:before {
				top: -5px;
			}

			&:after {
				bottom: -5px;
			}
		}

		/* active state */
		&.is-active {
			span {
				background-color: transparent !important;

				&:before {
					top: 0;
					transform: rotate(45deg);
					background-color: var(--color-brown);
				}

				&:after {
					bottom: 0;
					transform: rotate(-45deg);
					background-color: var(--color-brown);
				}
			}
		}
	}
</style>
